import { objToUrlParams } from '@/utils'
import request from '@/utils/request'

// 蚂蚁订单人工审核列表接口
export const getAntOrderReviewList = (params: any) => request({
  url: '/manage/ant/review/task',
  method: 'get',
  params
})

// 蚂蚁订单人工审核详情接口
export const getAntOrderDetail = (params: any) => request({
  url: `/manage/ant/review/task/${params}`,
  method: 'get'
})

// 新增蚂蚁订单【放弃】原因 - 下拉框动态配置
export const addAbandonReasonList = (data: any) => request({
  url: `/manage/ant/review/abandon-reason`,
  method: 'post',
  data
})

// 放弃原因列表
export const getAbandonReasonList = () => request({
  url: `/manage/ant/review/abandon-reason`,
  method: 'get'
})

// 对蚂蚁订单进行人工审核接口
export const getAntChangeStatus = (data: any) => request({
  url: `/manage/ant/review/task/${data.ordernumber}/change-status`,
  method: 'put',
  data
})
